import { BiteLogEigenEvent } from './bite_log_eigen_event.js';

export function name(event: BiteLogEigenEvent): string {
  switch (event) {
    case BiteLogEigenEvent.PaymentDeprecated:
      return 'payment';
    case BiteLogEigenEvent.TerminalDisconnected:
      return 'terminal-disconnected';
  }
}
